import {
  CarrierSchema,
  ServiceSchema,
} from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import * as z from "zod/v4";

const ChangeSchema_ = z.object({
  label: z.string(),
  old: z.string(),
  new: z.string(),
});

const SurchargeItemSchema_ = z.object({
  id: z.string(),
  trackingNumber: z.string().optional(),
  descriptions: z.array(z.string()),
  amount: z.string(),
  disputeId: z.string().optional(),
});

const ParcelChangesSchema_ = z.object({
  trackingNumber: z.string().optional(),
  changes: z.array(ChangeSchema_),
});

export const SurchargeItem: z.ZodType<SurchargeItem> = SurchargeItemSchema_;
export type SurchargeItem = z.infer<typeof SurchargeItemSchema_>;
export type ParcelChanges = z.infer<typeof ParcelChangesSchema_>;

export const getRelevantSurchargeData = {
  name: "getRelevantSurchargeData" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({
    carrier: CarrierSchema.optional(),
    serviceLevel: ServiceSchema.optional(),
    originalCost: z.string().optional(),
    totalAdjustment: z.string().optional(),
    updatedTotal: z.string().optional(),
    surcharges: z.array(SurchargeItemSchema_),
    parcelChanges: z.array(ParcelChangesSchema_),
  }),
};
